import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as ForPersonIcon } from '../../../assets/icons/sharing/verification-for-person.svg';
import AppButton from '../../../components/designe/buttons/app-button/AppButton';
import { successToastMessage } from '../../../components/layout/toast-root/toast';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';
import { Paths } from '../../../shared/paths';
import { handleAuthError } from '../../../utils/auth/auth-errors';
import { useStyles } from './SignUpVerification.styles';

const SignUpVerification = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { navigate } = useNavigationStack();
  const [sendingEmailState, setSendingEmailState] = React.useState(false);
  const [isSending, setIsSending] = React.useState(false);
  const { sendVerificationEmail } = useFirebaseAuth();

  async function onSendEmailClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    setIsSending(true);
    try {
      await sendVerificationEmail();
      successToastMessage(t('forgotPassword.emailSentMessage'));
      setSendingEmailState(true);
    } catch (error: unknown) {
      handleAuthError(error, t);
    } finally {
      setIsSending(false);
    }
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Box className={classes.iconCircle}>
          <ForPersonIcon className={classes.icon} aria-hidden />
        </Box>
        <Typography variant="h3" className={classes.title}>
          {t('errorPages.notVerified.title')}
        </Typography>
        <Typography variant="text-lg" className={classes.description}>
          {t('verification.checkEmail')}
        </Typography>

        <Box className={classes.resendWrapper}>
          {!sendingEmailState && (
            <AppButton
              type="button"
              className={classes.resendButton}
              variant="contained"
              loading={isSending}
              onClick={onSendEmailClick}>
              {t('common.resendTheEmail')}
            </AppButton>
          )}
        </Box>

        <AppButton
          className={classes.signInButton}
          variant="contained"
          onClick={() => navigate(Paths.signIn)}>
          {t('common.goToSignIn')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default SignUpVerification;
